module.exports = __webpack_public_path__ + "img/women_on_beach_mobile.95cb0058.jpg";